import { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "./firebase.js";

export default function useAuthUser() {
  const [user, setUser] = useState(() => auth.currentUser || null);
  const [loading, setLoading] = useState(!auth.currentUser);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => {
      setUser(u || null);
      setLoading(false);
    });
    return () => unsub();
  }, []);

  const hasMFA = !!(user?.multiFactor?.enrolledFactors?.length);
  const emailVerified = !!user?.emailVerified;
  return { user, loading, hasMFA, emailVerified };
}